import { styled } from '@mui/material/styles';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Popper from '@components/Popper';
import { Typography } from '@components/Typography';

export const StyledMenuItem = styled(MenuItem)({
    '& svg path': {
        fill: 'rgba(0, 0, 0, 0.6)',
    },
});

const MoreMenu = ({ className, id, menu, handleOpenEl, handleCloseEl, anchor, disabled }) => {
    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <IconButton onClick={e => handleOpenEl(e, id)} className={className}>
                    <MoreVertIcon viewBox="0 0 22 22" />
                </IconButton>
            </div>
            {anchor.id === id && (
                <ClickAwayListener onClickAway={handleCloseEl}>
                    <Popper anchorEl={anchor.el} open={!!anchor.el}>
                        {menu.map(item => (
                            <StyledMenuItem
                                key={item.id}
                                sx={{ gap: '8px', minWidth: '150px' }}
                                disabled={disabled}
                                onClick={item.onClick}
                            >
                                {item.icon}
                                <Typography variant="body2">{item.title}</Typography>
                            </StyledMenuItem>
                        ))}
                    </Popper>
                </ClickAwayListener>
            )}
        </>
    );
};

export default MoreMenu;
